<template>
  <state-overlay :open="open" title="ادامه‌ی فرآیند قبلی">
    <div class="iconcircle"><base-icon name="clock" /></div>
    <h2>ادامه‌ی فرآیند قبلی</h2>
    <p>
      شما پیش‌تر تا مرحله‌ی «<b>{{ stepLabel }}</b
      >» پیش رفته بودید. می‌خواهید از همان‌جا ادامه دهید یا از ابتدا شروع کنید؟
    </p>

    <template #foot>
      <button class="btn btn-primary" type="button" @click="$emit('resume')">
        ادامه از مرحله‌ی قبل
      </button>
      <button class="btn btn-outline" type="button" @click="$emit('restart')">شروع از ابتدا</button>
    </template>
  </state-overlay>
</template>

<script>
import StateOverlay from "./StateOverlay.vue";
import BaseIcon from "./BaseIcon.vue";
import { STEP_LABELS } from "@/constants";

/**
 * Offered on boot when a previous, unfinished run is still within its one-hour window.
 *
 * Naming the step the user reached is the point: "continue" is a much easier decision
 * when you can see it means you keep the photo and the video you already recorded.
 */
export default {
  name: "ResumeDialog",
  components: { StateOverlay, BaseIcon },

  props: {
    open: { type: Boolean, default: false },
    /** Route name of the step the user had reached. */
    step: { type: String, default: "" },
  },

  computed: {
    stepLabel() {
      return STEP_LABELS[this.step] || "مراحل قبلی";
    },
  },
};
</script>

<style scoped>
.iconcircle {
  margin: 0 auto;
}

p b {
  color: var(--foreground);
}
</style>
